/**
 * Dish Search Results Events & Constants
 * Event-driven architecture constants for dish search functionality
 */

export const EVENTS = {
  DISH_SEARCH: {
    REQUEST: 'dish.search.request',
    LOADING: 'dish.search.loading',
    LOADED: 'dish.search.loaded',
    ERROR: 'dish.search.error',
    LOAD_MORE: 'dish.load_more',
    LOADING_MORE: 'dish.loading_more',
    LOADED_MORE: 'dish.loaded_more',
    RESET: 'dish.search.reset',
  }
};

export const ENDPOINTS = {
  DISH_SEARCH: 'https://api.monrapidoo.com/rapidoo-aggregation/products-with-sides/search?group=ultraxeno&isPublished=true',
};

export const DEFAULT_STATE = {
  dishes: [],
  loading: false,
  error: null,
  hasMore: true,
  page: 1,
  totalCount: 0,
  searchQuery: '',
  filters: {},
};
